import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const Container = styled.div<{ $hasBackground?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ $hasBackground }) =>
    $hasBackground
      ? '#000000'
      : 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #0a0a0a 100%)'};
  padding: 48px;
  position: relative;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  width: 120px;
  height: 120px;
  margin-bottom: 32px;
  color: #4fc3f7;
  opacity: 0.8;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled.h1<{ $hasBackground?: boolean }>`
  font-size: 48px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 16px;
  text-align: center;
  ${({ $hasBackground }) =>
    $hasBackground &&
    `
    text-shadow: 0 2px 12px rgba(0,0,0,0.9), 0 0 4px rgba(0,0,0,0.7);
  `}
`;

export const Message = styled.p<{ $hasBackground?: boolean }>`
  font-size: 28px;
  color: #888888;
  text-align: center;
  max-width: 600px;
  margin-bottom: 48px;
  ${({ $hasBackground }) =>
    $hasBackground &&
    `
    color: #cccccc;
    text-shadow: 0 2px 12px rgba(0,0,0,0.9), 0 0 4px rgba(0,0,0,0.7);
  `}
`;

export const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  /* 2026-05-31 — reduzido de 48px → 16px pra colar a versão/device info
     logo abaixo do countdown (Renato pediu menos ar entre SEGUNDOS e
     Versão). DeviceInfo já tem margin-top: 16px próprio = total 32px. */
  margin-bottom: 16px;
`;

export const CountdownNumber = styled.div`
  font-size: 96px;
  font-weight: 700;
  color: #4fc3f7;
  line-height: 1;
  animation: ${pulse} 1s ease-in-out infinite;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.8);
`;

export const CountdownLabel = styled.span<{ $hasBackground?: boolean }>`
  font-size: 24px;
  color: #666666;
  text-transform: uppercase;
  letter-spacing: 2px;
  ${({ $hasBackground }) =>
    $hasBackground &&
    `
    color: #aaaaaa;
    text-shadow: 0 2px 8px rgba(0,0,0,0.8);
  `}
`;

export const StatusInfo = styled.div`
  display: flex;
  gap: 32px;
  padding: 16px 32px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
`;

export const StatusItem = styled.div<{
  $status: 'success' | 'error' | 'neutral';
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  color: ${({ $status }) =>
    $status === 'success'
      ? '#4caf50'
      : $status === 'error'
        ? '#f44336'
        : '#888888'};

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ $status }) =>
      $status === 'success'
        ? '#4caf50'
        : $status === 'error'
          ? '#f44336'
          : '#888888'};
  }
`;

export const DeviceInfo = styled.div<{ $hasBackground?: boolean }>`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.6;
  ${({ $hasBackground }) =>
    $hasBackground &&
    `
    background: rgba(0, 0, 0, 0.5);
    padding: 12px 24px;
    border-radius: 12px;
    backdrop-filter: blur(8px);
    opacity: 0.9;
  `}
`;

export const DeviceId = styled.span`
  font-size: 18px;
  color: #ffffff;
  font-family: monospace;
`;

export const NextAttempt = styled.span`
  font-size: 16px;
  color: #888888;
`;

export const ServerUrl = styled.span<{ $hasBackground?: boolean }>`
  font-size: 18px;
  color: #4fc3f7;
  font-family: monospace;
  margin-top: 8px;
  opacity: 0.8;
  ${({ $hasBackground }) =>
    $hasBackground &&
    `
    text-shadow: 0 1px 6px rgba(0,0,0,0.8);
  `}
`;
